import React from "react";
import { useNavigate, Link } from "react-router-dom";
import style from "./error404.module.css";

const Error404 = () => {
  const navigate = useNavigate();

  return (
    <section className={style.wrap} aria-labelledby="nf-title">
      <div className={style.bgDecor} aria-hidden="true">
        <span className={style.bubble} />
        <span className={style.bubble} />
        <span className={style.bubble} />
        <span className={style.bubble} />
      </div>

      <div className={style.card}>
        {/* Illustration */}
        <div className={style.illustration} aria-hidden="true">
          <svg viewBox="0 0 240 160" className={style.svg}>
            <defs>
              <linearGradient id="g1" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#29aae3"/>
                <stop offset="100%" stopColor="#7fd3f5"/>
              </linearGradient>
              <linearGradient id="g2" x1="0" y1="1" x2="1" y2="0">
                <stop offset="0%" stopColor="#cfefff"/>
                <stop offset="100%" stopColor="#e9f7ff"/>
              </linearGradient>
              <filter id="soft" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur in="SourceGraphic" stdDeviation="3" />
              </filter>
            </defs>

            <g transform="translate(10,18)">
              <ellipse cx="70" cy="60" rx="60" ry="28" fill="url(#g2)" />
              <ellipse cx="110" cy="50" rx="50" ry="24" fill="url(#g2)" />
              <ellipse cx="150" cy="64" rx="62" ry="26" fill="url(#g2)" />
            </g>

            <g transform="translate(110,20)">
              <rect x="6" y="30" width="8" height="78" rx="4" fill="#9ecfe7"/>
              <g filter="url(#soft)">
                <path d="M0,40 L55,40 L44,60 L0,60 Z" fill="url(#g1)"/>
              </g>
              <text x="10" y="54" fontFamily="Poppins, sans-serif" fontSize="10" fontWeight="700" fill="#fff">404</text>
            </g>

            <circle cx="32" cy="28" r="3" fill="#29aae3" />
            <circle cx="210" cy="24" r="2.5" fill="#8ed8f8" />
            <circle cx="194" cy="90" r="2.5" fill="#29aae3" />
          </svg>
        </div>

        <h1 id="nf-title" className={style.code}>Error 404</h1>
        <h2 className={style.title}>Page not found</h2>
        <p className={style.text}>
          The page you’re looking for doesn’t exist or has moved.
        </p>

        <div className={style.actions}>
          <button className={style.btn} onClick={() => navigate("/")}>
            Go home
          </button>
          <button className={style.btnGhost} onClick={() => navigate(-1)}>
            Go back
          </button>
          <Link to="/contact" className={style.linkHelp}>
            Report a problem
          </Link>
        </div>

        <div className={style.hint}>
          Try checking the URL or use the menu to find what you need.
        </div>
      </div>
    </section>
  );
};

export default Error404;
